import { ReactNode } from "react";
import HeaderComponent from "../../../../HeaderComponent";

interface NumberItemProps {
  title: string;
  number: number;
  fontSize: { sizes: { height: number; width: number }; scale: number };
  clickable: boolean;
  id: string;
  headerRight?: ReactNode;
}

const NumberItem = ({
  title,
  number,
  fontSize,
  clickable,
  id,
  headerRight,
}: NumberItemProps) => {
  const scaleNumber = number > 9999 ? 4.2 : 3.2;

  return (
    <div className="text-center component-height">
      <HeaderComponent
        title={title}
        clickable={clickable}
        id={id}
        rightContent={headerRight}
      />
      <div
        style={{ fontSize: `${fontSize.sizes.height / scaleNumber}px` }}
        className="pt-1 font-weight-bold number-item component-content content"
      >
        {number}
      </div>
    </div>
  );
};

export default NumberItem;
